import { createContext } from "react";

const NfcOrderListContext = createContext({});

export default NfcOrderListContext;
